/**
 * @module Swatch component
 */
import React, { PropTypes } from 'react';
import styles from './styles.scss';


/**
 * @type {Function} Swatch Stateless Component
 */
export function Swatch(props) {
  const {
    color, slim, inline, ...rest
  } = props;

  const mainStyles = {
    backgroundColor: color || 'transparent',
  };

  if (slim) {
    mainStyles.width = '1rem';
  }

  if (inline) {
    mainStyles.border = 'none';
  }

  return (
    <div className={styles.view} style={mainStyles} {...rest} />
  );
}


/**
 * TODO: specify the component propTypes of Swatch
 * Swatch propTypes
 */
Swatch.propTypes = {
  color: PropTypes.string,
  inline: PropTypes.bool,
  slim: PropTypes.bool,
};


/**
 * default export
 */
export default Swatch;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/swatch/index.jsx